"use client"

import { useInViewport } from "ahooks"
import clsx from "clsx"
import { useEffect, useRef, useState } from "react"
import { npPageWidthClassName, npSectionMtClassName } from "src/components/np-design/components/constants"
import { Ccm19EmbeddingName } from "src/integrations/ccm19/embeddings"
import { useCcm19EmbeddingAccepted } from "src/integrations/ccm19/useConsented"
import { MissingConsentNotice } from "src/integrations/lib/MissingConsentNotice"
import { pauseYouTubeVideo, playYouTubeVideo } from "src/integrations/youtube/state"
import { YouTubeIframe } from "src/integrations/youtube/YouTubeIframe"
import { YouTubeImage } from "src/integrations/youtube/YouTubeImage"

export type NpYouTubeVideoProps = {
  videoId: string
  videoTitle?: string
}

export const NpYouTubeVideo = ({ videoId, videoTitle = "Video" }: NpYouTubeVideoProps) => {
  const consented = useCcm19EmbeddingAccepted(Ccm19EmbeddingName.YouTube)
  const ref = useRef<any>(null)
  const [inViewOnce, setInViewOnce] = useState(false)
  const [inViewNow, setInViewNow] = useState(false)

  useInViewport(ref, {
    callback: (entry) => {
      if (!inViewOnce && entry.isIntersecting) {
        setInViewOnce(true)
      }
      setInViewNow(entry.isIntersecting)
    },
  })

  useEffect(() => {
    if (consented && inViewNow) {
      playYouTubeVideo()
    } else {
      pauseYouTubeVideo()
    }
  }, [consented, inViewNow])

  return (
    <section
      ref={ref}
      title={videoTitle}
      aria-label={"YouTube-Video: " + videoTitle}
      className={clsx(npSectionMtClassName, npPageWidthClassName)}
    >
      <div
        aria-label={videoTitle}
        className={clsx(
          "w-page:rounded-3xl relative flex aspect-video items-center justify-center overflow-hidden bg-black",
          npPageWidthClassName,
        )}
      >
        {consented && inViewOnce ? (
          <YouTubeIframe videoId={videoId} autoPlay mute loop enablejsapi />
        ) : (
          <YouTubeImage videoId={videoId} videoTitle={videoTitle} />
        )}

        {!consented && <MissingConsentNotice consentId={Ccm19EmbeddingName.YouTube} />}
      </div>
    </section>
  )
}
